(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('templates/dirPagination.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2026 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<ul class="pagination" ng-if="1 < pages.length || !autoHide">',
'    <li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }">',
'        <a ng-click="setCurrent(1)">&laquo;</a>',
'    </li>',
'    <li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }">',
'        <a ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a>',
'    </li>',
'    <li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }">',
'        <a ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a>',
'    </li>',
'',
'    <li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }">',
'        <a ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a>',
'    </li>',
'    <li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }">',
'        <a ng-click="setCurrent(pagination.last)">&raquo;</a>',
'    </li>',
'</ul>',
'',''].join("\n"));
  }]);
})();